<template>
    <div>
      <!--顶部按钮-->
      <div class="app-container">
        <!-- <vxe-button  @click="deriveFun">导出</vxe-button> -->
        <div style="display: flex; justify-content: end">
          <div v-if="!showFilter">
            <a-select v-if="activeName==='first'" v-model="queryCondition.regionId" placeholder="请选择经理部" clearable style="width: 200px; margin-right: 1rem">
                <a-select-option
                  v-for="item in sectorList"
                  :key="item.sectorId"
                  :value="item.sectorId"
                >{{ item.sectorName }}</a-select-option>
              </a-select>
            <a-input v-model="queryCondition.nameOrCode" :placeholder="placeholderMsg" clearable style="width: 200px; margin-right: 1rem" @change="queryByPage()" />
          </div>
          <div>
            <vxe-button v-if="!showFilter" status="primary" @click="handSearch()">搜索</vxe-button>
            <vxe-button v-if="!showFilter" class="filter-search-item" @click="resetForm">重置</vxe-button>
            <vxe-button @click="cb">
                {{ showFilter ? '收起' : '更多选项' }}
            </vxe-button>
          </div>
        </div>
        <!--筛选拓展-->
        <div>
          <!-- <el-collapse-transition> -->
            <!-- cb001 -->
            <!-- <div v-if="showFilter"> -->
              <div v-if="showFilter">
                <br>
                <a-form label-width="110px" class="SiftActivity UniformCss">
                  <a-row>
                    <a-col :span="4">
                      <a-form-item label="提报编码：">
                        <a-input v-model="queryCondition.activityCode" clearable />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="活动名称：">
                        <a-input v-model="queryCondition.activityName" clearable />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="经理部：">
                        <!-- <a-select v-model="queryCondition.regionId" placeholder="请选择经理部" clearable>
                          <a-select-option v-for="item in sectorList" :key="item.sectorId" :label="item.sectorName" :value="item.sectorId" />
                        </a-select> -->

                        <a-select v-model="queryCondition.regionId" clearable style="margin-right: 1rem">
                          <a-select-option
                              v-for="(item) in sectorList"
                              :key="item.sectorId"
                              :value="item.sectorId"
                          >{{ item.sectorName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="审批类型：">
                        <!-- <a-select v-model="queryCondition.eventType" clearable>
                          <a-select-option v-for="(item, i) in typesOfPresentation" :key="i" :value="item.value" :label="item.value" />
                        </a-select> -->

                        <a-select v-model="queryCondition.eventType" clearable style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item,i) in typesOfPresentation"
                            :key="i"
                            :value="item.value"
                          >{{ item.value }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="审批状态：">
                         <a-select v-model="queryCondition.eventStatus" clearable :disabled="!queryCondition.eventType" style="margin-right: 1rem">
                          <a-select-option
                              v-for="status in eventStatusOptions[queryCondition.eventType] || []"
                              :key="status"
                              :value="status"
                          >{{ status }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="经销商：">
                        <a-input v-model="queryCondition.dealerShortName" clearable />
                      </a-form-item>
                    </a-col>
                    <!-- <a-col :span="6">
                      <a-form-item label="申请月份从：">
                        <el-date-picker class="a_height" v-model="queryCondition.actMonthStart" value-format="yyyy-MM" type="month" placeholder="选择日期" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="至：">
                        <el-date-picker class="a_height" v-model="queryCondition.actMonthEnd" value-format="yyyy-MM" type="month" placeholder="选择日期" />
                      </a-form-item>
                    </a-col> -->
                    <a-col :span="4">
                      <a-form-item label="预算类型：">
                        <a-select v-model="queryCondition.budgetTypeCode" clearable style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item) in budgetData"
                            :key="item.valueCode"
                            :value="item.valueCode"
                          >{{ item.valueName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <!-- <a-col :span="6">
                      <a-form-item label="计划名称：">
                        <a-input v-model="queryCondition.planName" clearable />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="计划编码：">
                        <a-input v-model="queryCondition.planCode" clearable />
                      </a-form-item>
                    </a-col> -->
                    <!-- <a-col :span="6">
                      <a-form-item label="申请人：">
                        <a-input v-model="queryCondition.createUserName" clearable />
                      </a-form-item>
                    </a-col> -->
                    <!-- <a-col :span="6">
                      <a-form-item label="客户来源：">

                        <a-select v-model="queryCondition.custSourceCode" clearable @change="custSourceChange" style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item) in custSourceList"
                            :key="item.code"
                            :value="item.code"
                          >{{ item.name }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col> -->
                    <a-col :span="4">
                      <a-form-item label="一级来源：">
                        <!-- <a-select v-model="queryCondition.oneLevelCode" filterable clearable @change="oneSourceChange">
                          <a-select-option
                            v-for="item in oneSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                            :label="item.sourceName"
                          />
                        </a-select> -->
                        <a-select v-model="queryCondition.oneLevelCode" clearable @change="oneSourceChange" style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item) in oneSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                          >{{ item.sourceName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="二级来源：">
                        <!-- <a-select v-model="queryCondition.twoLevelCode" filterable clearable @change="twoSourceChange">
                          <a-select-option
                            v-for="item in twoSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                            :label="item.sourceName"
                          />
                        </a-select> -->
                        <a-select v-model="queryCondition.twoLevelCode" clearable @change="twoSourceChange" style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item) in twoSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                          >{{ item.sourceName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="三级来源：">
                        <!-- <a-select v-model="queryCondition.threeLevelCode" filterable clearable>
                          <a-select-option
                            v-for="item in threeSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                            :label="item.sourceName"
                          />
                        </a-select> -->
                        <a-select v-model="queryCondition.threeLevelCode" clearable style="margin-right: 1rem">
                          <a-select-option
                            v-for="(item) in threeSourceList"
                            :key="item.sourceCode"
                            :value="item.sourceCode"
                          >{{ item.sourceName }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="计划开始时间从：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.planStartTimeBegin"
                            picker="date"
                            placeholder="选择日期"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="至：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.planStartTimeEnd"
                            picker="date"
                            placeholder="选择日期"
                            :picker-options="{ disabledDate: time => time.getTime() < new Date(queryCondition.planStartTimeBegin) - 8.64e7 }"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="计划结束时间从：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.planEndTimeBegin"
                            picker="date"
                            placeholder="选择日期"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="至：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.planEndTimeEnd"
                            picker="date"
                            placeholder="选择日期"
                            :picker-options="{ disabledDate: time => time.getTime() < new Date(queryCondition.planEndTimeBegin) - 8.64e7 }"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="发起时间从：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.eventStartTimeBegin"
                            picker="date"
                            placeholder="选择日期"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="至：">
                        <a-date-picker
                            valueFormat="YYYY-MM-DD"
                            v-model="queryCondition.eventStartTimeEnd"
                            picker="date"
                            placeholder="选择日期"
                            :picker-options="{ disabledDate: time => time.getTime() < new Date(queryCondition.eventStartTimeBegin) - 8.64e7 }"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-form-item label="品系：">
                        <a-select v-model="queryCondition.strainsName" clearable style="margin-right: 1rem">
                          <a-select-option
                              v-for="item in carStrainsDS"
                              :key="item.strainsCode"
                              :value="item.strains" >{{item.strains}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <!--<a-col :span="4">-->
                  </a-row>
                </a-form>
                <div slot="footer" style="text-align: center; padding-bottom: 10px">
                  <!-- <el-button type="info" icon="el-icon-refresh" @click="resetForm">重置</el-button>
                  <el-button type="primary" icon="el-icon-search" @click="handSearch()">查询</el-button> -->
                  <vxe-button class="filter-search-item" @click="resetForm">重置</vxe-button>
                  <vxe-button status="primary" @click="handSearch()">搜索</vxe-button>
                </div>
              <!-- </div> -->
            </div>
          <!-- </el-collapse-transition> -->
        </div>
        <!--table列表-->
        <!-- lr0034 -->
        <el-tabs v-model="activeName" @tab-click="resetForm" class="tabsClass">
          <el-tab-pane label="待办事项" name="first">
<!--            <vxe-toolbar ref="toolbarRef" custom style="height:39px;margin-top:-2px;background: #F3F4F7;" />-->
            <div style="background: #F3F4F7; display: flex; align-items: center; gap: 8px;">
              <vxe-button v-auth="`BATCHAPPROVEINACTIVITY`" status="primary" @click="batchApproveDialogVisible = true" style="margin-left: 10px">
                批量审批
              </vxe-button>
              <vxe-toolbar ref="toolbarRef" custom style="flex: 1; height: 43px; background: #F3F4F7;" />
            </div>
            <vxe-table
              id="toolbar_undoList"
              ref="xTable"
              v-loading="listLoading"
              :align="allAlign"
              :max-height="$store.state.app.height - 175 < 500 ? 500 : $store.state.app.height - 175"
              border
              show-header-overflow
              show-overflow
              class="mytable-scrollbar"
              :column-config="{ resizable: true }"
              :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
              stripe
              round
              :sort-config="{remote: true}"
              :scroll-y="{ enabled: false }"
              :row-config="{ isCurrent: true, isHover: true }"
              :data="tableData"
              @sort-change="listSortMethod"
              @cell-dblclick="cellClickEvent"
            >
              <vxe-column type="checkbox" width="60" align="center" />
              <vxe-column type="seq" title="序号" width="60" align="center" />
              <!-- <vxe-column field="eventId" :visible="false" title="id" width="150" /> -->
              <!-- <vxe-column field="orderId" :visible="false" title="流程id" width="150" /> -->
              <vxe-column field="planName" :visible="false" title="计划名称" width="150" />
              <vxe-column field="planCode" :visible="false" title="计划编码" width="130" />
              <vxe-column field="eventCode" title="提报编码" width="130" />
              <vxe-column field="eventType" title="审批类型" width="100" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <!-- <span v-if="row.eventType==='时间调整'" style="color:#67C23A">{{ row.eventType }}</span> -->
                    <span v-if="row.eventType==='核销审批'" style="color:#F56C6C">{{ row.eventType }}</span>
                    <span v-if="row.eventType==='提报审批'" style="color:#409EFF">{{ row.eventType }}</span>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="sectorName" title="经理部" width="100" align="center" />
              <vxe-column field="dealerShortName" title="经销商" width="120" align="center" />
              <vxe-column field="createUserName" title="申请人" width="100" align="center"/>
              <vxe-column field="eventName" title="活动名称" width="150" align="center"/>
              <vxe-column field="budgetTypeName" title="预算类型" width="100" align="center" />
              <!-- <vxe-column field="custSourceName" title="客户来源" width="120" align="center" /> -->
              <vxe-column field="oneLevelName" title="一级来源" width="120" align="center" />
              <vxe-column field="twoLevelName" title="二级来源" width="120" align="center" />
              <vxe-column field="threeLevelName" title="三级来源" width="120" align="center" />
              <!-- <vxe-column field="eventNode" title="当前流程节点" width="150" /> -->
              <!-- <vxe-column field="currentApproveUser" title="当前审批人" width="120" /> -->
              <!-- <vxe-column field="orderId" title="审批信息" width="120" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <el-link type="primary" @click="viewApproveDetail(row)">详情</el-link>
                  </div>
                </template>
              </vxe-column> -->
              <vxe-column field="planStartTime" title="计划开始时间" width="100" />
              <vxe-column field="planEndTime" title="计划结束时间" width="100" />
              <vxe-column field="strainsNameList" title="品系" width="150" />
              <vxe-column field="eventStartTime" title="发起时间" width="150" />
              <vxe-column field="eventStatus" title="审批状态" width="100" />
              <!-- <vxe-column field="actMonth" title="申请月份" width="150" /> -->
              <!-- <vxe-column field="dealerName" title="流程信息" width="120" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <el-link type="primary" @click="viewProcessDetail(row)">查看</el-link>
                  </div>
                </template>
              </vxe-column> -->
              <vxe-column title="操作" field="address" width="110" fixed="right" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <!-- <el-link type="primary" icon="el-icon-d-arrow-right" @click="viewDetail(row)">跳转审批页</el-link> -->
                    <a-button size="small" v-auth="`VIEW`" type="link" status="primary" @click="viewDetail(row)">审核</a-button>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
            <vxe-pager
              :current-page="pagination.current"
              :page-size="pagination.size"
              :total="pagination.total"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
              @page-change="changePage"
            />
            <vxe-modal v-model="showDetails" title="查看详情" width="600" height="400" :mask="false" :lock-view="false" resize>
              <template #default>
                <vxe-table
                  border="inner"
                  auto-resize
                  show-overflow
                  height="auto"
                  :row-config="{isHover: true}"
                  :show-header="false"
                  :sync-resize="showDetails"
                  :data="detailData"
                >
                  <vxe-column field="label" width="40%" />
                  <vxe-column field="value" />
                </vxe-table>
              </template>
            </vxe-modal>
          </el-tab-pane>
          <el-tab-pane label="已办事项" name="second">
            <vxe-table
              ref="xTable2"
              v-loading="listLoading2"
              :align="allAlign"
              :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
              border
              show-header-overflow
              show-overflow
              class="mytable-scrollbar"
              :column-config="{ resizable: true }"
              stripe
              round
              :sort-config="{remote: true}"
              :scroll-y="{ enabled: false }"
              :row-config="{ isHover: true }"
              :data="tableData2"
              @sort-change="listSortMethod"
            >
              <vxe-column type="checkbox" width="60" align="center" />
              <vxe-column type="seq" title="序号" width="60" align="center" />
              <!-- <vxe-column field="eventId" :visible="false" title="id" width="150" /> -->
              <!-- <vxe-column field="orderId" :visible="false" title="id" width="150" /> -->
              <vxe-column field="eventCode" title="提报编码" width="130" />
              <vxe-column field="eventType" title="审批类型" width="100" align="center" >
                <template #default="{ row }">
                  <div class="operate">
                    <!-- <span v-if="row.eventType==='时间调整'" style="color:#67C23A">{{ row.eventType }}</span> -->
                    <span v-if="row.eventType==='核销审批'" style="color:#F56C6C">{{ row.eventType }}</span>
                    <span v-if="row.eventType==='提报审批'" style="color:#409EFF">{{ row.eventType }}</span>
                  </div>
                </template>
              </vxe-column>
              <vxe-column field="sectorName" title="经理部" width="100" align="center" />
              <vxe-column field="dealerShortName" title="经销商" width="120" align="center" />
              <vxe-column field="createUserName" title="申请人" width="100" />
              <vxe-column field="eventName" title="活动名称" width="150" />
              <vxe-column field="budgetTypeName" title="预算类型" width="100" align="center" />
              <vxe-column field="oneLevelName" title="一级来源" width="120" align="center" />
              <vxe-column field="twoLevelName" title="二级来源" width="120" align="center" />
              <vxe-column field="threeLevelName" title="三级来源" width="120" align="center" />
              <vxe-column field="planStartTime" title="计划开始时间" width="100" />
              <vxe-column field="planEndTime" title="计划结束时间" width="100" />
              <vxe-column field="strainsNameList" title="品系" width="150" />
              <vxe-column field="eventStartTime" title="发起时间" width="150" />
              <vxe-column field="eventStatus" title="审批状态" width="100" />
              <!-- <vxe-column field="orderId" title="审批信息" width="120" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <el-link type="primary" @click="viewApproveDetail(row)">查看</el-link>
                  </div>
                </template>
              </vxe-column> -->
              <!-- <vxe-column field="eventStartTime" title="申请时间" width="150" /> -->
              <!-- <vxe-column field="dealerName" title="流程信息" width="130" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <el-link type="primary" @click="viewProcessDetail(row)">查看</el-link>
                  </div>
                </template>
              </vxe-column> -->
              <vxe-column title="操作" width="160" fixed="right" align="center">
                <template #default="{ row }">
                  <div class="operate">
                    <!-- <el-link type="primary" icon="el-icon-d-arrow-right" @click="viewDetail(row)">详情</el-link> -->
                    <a-button size="small" v-auth="`VIEW`" type="link" status="primary" @click="viewDetail(row)">查看</a-button>
                  </div>
                </template>
              </vxe-column>
            </vxe-table>
            <vxe-pager
              :current-page="pagination2.current"
              :page-size="pagination2.size"
              :total="pagination2.total"
              :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
              @page-change="changePage2"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <!--导入对话框 -->
  
      <el-dialog title="审批信息" :visible.sync="taskDialogVisible" width="60%">
        <vxe-table
          ref="xApprove"
          border
          show-header-overflow
          show-overflow
          :column-config="{ resizable: true }"
          stripe
          round
          :loading="approveLoading"
          max-height="370"
          :align="allAlign"
          :scroll-y="{ enabled: false }"
          :data="taskListData"
          :reserve="true"
          :row-config="{ isCurrent: true, isHover: true }"
        >
          <vxe-column type="seq" title="序号" width="60" />
          <vxe-column field="displayName" title="节点名称" />
          <vxe-column field="operatorName" title="审批人" />
          <vxe-column field="operateType" title="操作类型" />
          <vxe-column field="approveMsg" title="审批意见" />
          <vxe-column field="finishTime" title="处理时间" />
        </vxe-table>
      </el-dialog>
  
      <el-dialog title="流程信息" :visible.sync="processDialogVisible" width="60%">
        <vxe-table
          ref="xProcess"
          border
          show-header-overflow
          show-overflow
          :column-config="{ resizable: true }"
          stripe
          round
          :loading="processLoading"
          max-height="370"
          :align="allAlign"
          :scroll-y="{ enabled: false }"
          :data="processListData"
          :reserve="true"
          :row-config="{ isCurrent: true, isHover: true }"
        >
          <vxe-column type="seq" title="执行顺序" width="100" />
          <vxe-column field="displayName" title="节点名称" />
        </vxe-table>
      </el-dialog>
      <!--导出对话框 -->
      <a-modal title="选择导出项" v-model="dialogVisible" width="400px">
        <a-radio-group v-model="ExportItem">
          <a-radio :value="1">导出当前页</a-radio>
          <a-radio :value="2" :disabled="disabled">导出已选择项</a-radio>
        </a-radio-group>
        <span slot="footer" class="dialog-footer">
          <vxe-button size="small" @click="dialogVisible = false">取 消</vxe-button>
          <vxe-button size="small" status="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
        </span>
      </a-modal>

      <a-modal title="批量审批信息" :visible.sync="batchApproveDialogVisible" width="40%" @cancel="batchApproveDialogVisible = false">
        <el-input
            v-model="batchApproveMsg"
            type="textarea"
            placeholder="请输入审批意见"
            maxlength="300"
            show-word-limit
        />
        <span slot="footer" class="dialog-footer">
        <vxe-button status="primary" :loading="batchApproveBtnLoading" @click="approveBatch()">同意</vxe-button>
        <vxe-button @click="batchApproveDialogVisible = false">取 消</vxe-button>
      </span>
      </a-modal>
    </div>
  </template>
  
  <script>
//   import permission from '@/directive/permission/index.js' // 权限判断指令
  import { outExcel } from '@/utils/Excel/outExcel'
  import { findSectorList } from '@/api/base-data'
  import { findList, findHistTask, findTaskInfos, findProcessInfos } from '@/api/wf_process'
  import { queryValueTypeByCode,queryCarStrainsInfo } from '@/api/activity' // 活动类接口
  import { getSourceSelectList, getCustSourceSelect } from '@/api/base-data'
  import {approveApplyBatchInDb} from "@/api/actPlan";
  import {mapGetters} from "vuex";
  const defaultPagination = {
    total: 0,
    size: 20,
    current: 1
  }
  const defaultTypesOfPresentation = [
     /*{
      code: 1,
      value: '时间调整'
    },*/
    {
      code: 2,
      value: '提报审批'
    },
    {
      code: 3,
      value: '核销审批'
    }
  ]
  const defaultEventStatusOptions = {
      "提报审批": ["填报中", "审批中", "审批通过", "已驳回", "不通过"],
      "核销审批": ["待反馈", "待核销", "审批中", "审批通过", "已驳回", "放弃核销", "不通过"]
    }
  export default {
    name: 'MyToDoListIndex',
    // inject: ['reload'],
    // directives: { permission },
    data() {
      return {
        // showFilter: false,
        // pagination: Object.assign({}, defaultPagination),
        pagination2: Object.assign({}, defaultPagination),
        listLoading: false,
        listLoading2: false,
        processDialogVisible: false,
        processLoading: false,
        showDetails: false,
        detailData: [],
        taskListData: [],
        sectorList: [],
        budgetData: [],
        carStrainsDS: [],
        // queryCondition: {},
        typesOfPresentation: defaultTypesOfPresentation,
        eventStatusOptions: defaultEventStatusOptions,
        taskDialogVisible: false,
        approveLoading: false,
        tableData2: [],
        processListData: [],
  
        activeName: 'first',
        tableData: [],
        sort: 'create_time desc',
        allAlign: 'center',
        placeholderMsg: '活动名称/活动编码/经销商名称',
        nameOrCode: '',
        // 导出对话框
        dialogVisible: false,
        disabled: true, // 已选择按钮是否禁用
        outExcelButtonLocading: false,
        ExportItem: 0,
        batchApproveDialogVisible: false,
        batchApproveBtnLoading: false,
        batchApproveMsg: '',
      }
    },
    computed: {
      queryCondition() {
        return this.$store.state.undoListPage.queryCondition
      },
      pagination() {
        return this.$store.state.undoListPage.pagination
      },
      showFilter() {
        return this.$store.state.undoListPage.showFilter
      },
      custSourceList() {
        return this.$store.state.undoListPage.sourceList.custSourceList
      },
      oneSourceList() {
        return this.$store.state.undoListPage.sourceList.oneSourceList
      },
      twoSourceList() {
        return this.$store.state.undoListPage.sourceList.twoSourceList
      },
      threeSourceList() {
        return this.$store.state.undoListPage.sourceList.threeSourceList
      },
      ...mapGetters('account', ['user']),
    },
    watch: {
      activeName(val) {
        if (val === 'first') {
          this.placeholderMsg = '活动名称/活动编码/经销商名称'
        } else {
          this.$store.commit('undoListPage/updateShowFilter', false)
          this.placeholderMsg = '活动名称/活动编码'
        }
      }
    },
    created() {
      // 获取表格数据
      this.queryByPage()
      // 获取大区
      this.getSectorList()
      // 获取预算类型
      this.getBudgettype()
      // 客户来源下拉框
      this.getCustSelectList()
  
      this.$nextTick(() => {
        // 手动将表格和工具栏进行关联
        this.$refs.xTable.connect(this.$refs.toolbarRef)
      })
      // 获取活动来源下拉框数据
      this.getFiveSource(1)

      //获取品系
      this.getCarStrains()
    },
    mounted() {},
    methods: {
      deriveFun() {
        this.dialogVisible = true
        // 判断是否选中
        this.disabled = this.activeName === 'first' ? this.$refs.xTable.selection.length < 1 : this.$refs.xTable2.selection.length < 1
      },
      cellClickEvent({ row }) {
        this.detailData = [{
          field: 'planName',
          title: '计划名称'
        },
        {
          field: 'planCode',
          title: '计划编码'
        },
        {
          field: 'eventCode',
          title: '提报编码'
        },
        {
          field: 'eventType',
          title: '审批类型'
        },
        {
          field: 'sectorName',
          title: '经理部'
        },
        {
          field: 'dealerShortName',
          title: '经销商'
        },
        {
          field: 'createUserName',
          title: '申请人'
        },
        {
          field: 'eventName',
          title: '提报名称'
        },
        {
          field: 'budgetTypeName',
          title: '预算类型'
        },
    //    {
    //      field: 'custSourceName',
    //      title: '客户来源'
    //    },
        {
          field: 'oneLevelName',
          title: '一级来源'
        },
        {
          field: 'twoLevelName',
          title: '二级来源'
        },
        {
          field: 'threeLevelName',
          title: '三级来源'
        },
        {
          field: 'eventNode',
          title: '当前审批节点'
        },
        {
          field: 'currentApproveUser',
          title: '当前审批人'
        },
        {
          field: 'planStartTime',
          title: '计划开始时间'
        },
        {
          field: 'planEndTime',
          title: '计划结束时间'
        },
        {
          field: 'strainsNameList',
          title: '品系'
        },
        {
          field: 'eventStartTime',
          title: '发起时间'
        },
        {
          field: 'eventStatus',
          title: '审批状态'
        }].map(obj => {
          return { label: obj.title, value: row[obj.field] }
        })
        this.showDetails = true
      },
      // 导出表格
      async exportXlsxFun() {
        // 需要导出的数据
        let data = []
        this.outExcelButtonLocading = true
        if (this.ExportItem == 1) {
          data = this.activeName === 'first' ? this.tableData : this.tableData2
        }
        if (this.ExportItem == 2) {
          data = this.activeName === 'first' ? this.$refs.xTable.selection : this.$refs.xTable2.selection
        }
        const table = []
        for (var i = 0; i < data.length; i++) {
          var params = {
            事项名称: data[i].eventName,
            事项类型: data[i].eventType,
            当前流程节点: this.activeName === 'first' ? data[i].eventNode : '您已审批',
            当前审批人: this.activeName === 'first' ? data[i].currentApproveUser : '您已审批',
            申请人: data[i].createUser,
            申请时间: data[i].eventStartTime
          }
          table[i] = params
        }
        const wch = [15, 15, 15, 15, 15, 25]
        outExcel('审批信息表', table, wch)
        // 关闭弹窗
        this.dialogVisible = false
        this.outExcelButtonLocading = false
      },
      checkColumnMethod({ column }) {
        if (column.field === 'eventId' || column.field === 'orderId') {
          return false
        }
        return true
      },
      // 获取大区
      getSectorList() {
        findSectorList().then(res => {
          if (res.code === 1 && res.data) {
            this.sectorList = res.data
          }
        })
      },
      // 获取预算类型
      getBudgettype() {
        queryValueTypeByCode({ typeCode: 'budgetary', page: 1, limit: 999 }).then(res => {
          if (res.code === 1) {
            this.budgetData = res.data.list
          }
        })
      },
      listSortMethod({ column, sortList }) {
        console.log(column);
        
        let sort = ''
        for (let i = 0; i < sortList.length; i++) {
          if (i !== 0) {
            sort = sort + ','
          }
          sort = sort + sortList[i].field + ' ' + sortList[i].order
        }
        this.sort = sort
        this.queryByPage()
      },
      viewProcessDetail(row) {
        this.processDialogVisible = true
        this.processLoading = true
        const param = {
          orderId: row.orderId
        }
        findProcessInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.processListData = res.data
            this.processLoading = false
          }
        })
      },
      viewApproveDetail(row) {
        this.taskDialogVisible = true
        this.approveLoading = true
        const param = {
          orderId: row.orderId
        }
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.taskListData = res.data
            this.taskListData.forEach(item => {
              if (!item.his) {
                item.operatorName = row.currentApproveUser
                item.finishTime = '正在处理'
              }
            })
            this.approveLoading = false
          }
        })
      },
      viewDetail(row) {
        // this.$router.push({ 
        //   path: `/publicizeMaterialManagement/applyOrderDetail/${row.eventId}` , 
        //   query: { orderStatus: row.eventStatus, applyOrderId: row.orderId,type:'myToDolistShiChang' }
        // })
        if (row.eventType === '提报审批') {
          if(row.eventStatus === '已驳回'&& this.activeName === 'first'){
            this.$router.push({
              path: `editSignActivity/${row.eventId}`,
              query: { type:'myToDolistShiChangTiBao' }
            })
          }else {
            this.$router.push({
              path: `signDetails/${row.eventId}`,
              query: { type:'myToDolistShiChangTiBao' }
            })
          }
        }
        if (row.eventType === '核销审批') {
          this.$router.push({
            path: `detailedReimbursement/${row.eventId}`,
            query: { type:'myToDolistShiChangHeXiao' }
          })
        }
        if (row.eventType === '时间调整') {
          // this.$router.push({
          //   path: `market_activity/center/editSignActivityDate/${row.eventId}/approve`
          // })
        }
      },
      // 分页
      changePage({ currentPage, pageSize }) {
        this.pagination.current = currentPage
        if (pageSize != this.pagination.size) this.pagination.current = 1
        this.pagination.size = pageSize
        this.queryByPage()
      },
      changePage2({ currentPage, pageSize }) {
        this.pagination2.current = currentPage
        if (pageSize != this.pagination2.size) this.pagination2.current = 1
        this.pagination2.size = pageSize
        this.queryByPage2()
      },
      // 重置筛选
      resetForm() {
        this.$store.commit('undoListPage/resetQueryCondition')
        this.handSearch()
      },
      // 查询表格数据
      queryByPage(e) {
        if (e) this.pagination.current = e
  
        // 保存查询条件到store
        this.$store.commit('undoListPage/updatePagination', this.pagination)
        this.$store.commit('undoListPage/updateQueryCondition', this.queryCondition)
  
        // 筛选条件
        const queryData = {
          page: this.pagination.current,
          limit: this.pagination.size,
          sort: this.sort,
          conditions: [
            {
              code: 'eventName',
              symbol: 'like',
              values: this.queryCondition.nameOrCode
            },
            {
              code: 'eventCode',
              symbol: 'like',
              values: this.queryCondition.nameOrCode
            },
            {
              code: 'dealerShortName',
              symbol: 'like',
              values: this.queryCondition.nameOrCode
            }
          ],
          conditionsAnd: [
            {
              code: 'eventType',
              symbol: 'like',
              values: this.queryCondition.eventType
            },
            {
              code: 'eventStatus',
              symbol: 'like',
              values: this.queryCondition.eventStatus
            },
            /*{
              code: 'actMonth',
              symbol: 'between',
              values: this.queryCondition.actMonthStart,
              valuesTwo: this.queryCondition.actMonthEnd
            },*/
            {
              code: 'activityName',
              symbol: 'like',
              values: this.queryCondition.activityName
            },
            {
              code: 'budgetTypeCode',
              symbol: '=',
              values: this.queryCondition.budgetTypeCode
            },
            /*{
              code: 'planCode',
              symbol: 'like',
              values: this.queryCondition.planCode
            },
            {
              code: 'planName',
              symbol: 'like',
              values: this.queryCondition.planName
            },*/
            {
              code: 'activityCode',
              symbol: 'like',
              values: this.queryCondition.activityCode
            },
            {
              code: 'regionId',
              symbol: '=',
              values: this.queryCondition.regionId
            },
            {
              code: 'dealerShortName',
              symbol: 'like',
              values: this.queryCondition.dealerShortName
            },
            /*{
              code: 'createUserName',
              symbol: 'like',
              values: this.queryCondition.createUserName
            },*/
            {
              code: 'eventStartTime',
              symbol: 'between',
              values: this.queryCondition.eventStartTimeBegin,
              valuesTwo: this.queryCondition.eventStartTimeEnd
            },
            {
              code: 'planStartTime',
              symbol: 'between',
              values: this.queryCondition.planStartTimeBegin,
              valuesTwo: this.queryCondition.planStartTimeEnd
            },
            {
              code: 'planEndTime',
              symbol: 'between',
              values: this.queryCondition.planEndTimeBegin,
              valuesTwo: this.queryCondition.planEndTimeEnd
            },
            {
              code: 'oneLevelCode',
              symbol: 'like',
              values: this.queryCondition.oneLevelCode
            },
            {
              code: 'twoLevelCode',
              symbol: 'like',
              values: this.queryCondition.twoLevelCode
            },
            {
              code: 'threeLevelCode',
              symbol: 'like',
              values: this.queryCondition.threeLevelCode
            },
            /*{
              code: 'custSourceCode',
              symbol: 'like',
              values: this.queryCondition.custSourceCode
            },*/
            {
              code: 'strainsName',
              symbol: 'like',
              values:this.queryCondition.strainsName
            }
          ]
        }
        this.listLoading = true // 开启加载动画
        findList(queryData).then(res => {
          if (res.code === 1 && res.data) {
            this.tableData = res.data.list
            console.log(this.tableData)
            this.pagination.total = res.data.total
            this.listLoading = false
          }
        })
      },
      // 查询表格数据
      queryByPage2(e) {
        if (e) this.pagination2.current = e
        // 筛选条件
        const queryData = {
          page: this.pagination2.current,
          limit: this.pagination2.size,
          sort: this.sort,
          conditions: [{
            code: 'activityName',
            symbol: 'like',
            values: this.queryCondition.nameOrCode
          },
          {
            code: 'activityCode',
            symbol: 'like',
            values: this.queryCondition.nameOrCode
          }],
          conditionsAnd: [
            {
              code: 'eventType',
              symbol: 'like',
              values: this.queryCondition.eventType
            },
            {
              code: 'eventStatus',
              symbol: 'like',
              values: this.queryCondition.eventStatus
            },
            {
              code: 'activityName',
              symbol: 'like',
              values: this.queryCondition.activityName
            },
            {
              code: 'budgetTypeCode',
              symbol: '=',
              values: this.queryCondition.budgetTypeCode
            },
            {
              code: 'activityCode',
              symbol: 'like',
              values: this.queryCondition.activityCode
            },
            {
              code: 'regionId',
              symbol: '=',
              values: this.queryCondition.regionId
            },
            {
              code: 'dealerShortName',
              symbol: 'like',
              values: this.queryCondition.dealerShortName
            },
            {
              code: 'eventStartTime',
              symbol: 'between',
              values: this.queryCondition.eventStartTimeBegin,
              valuesTwo: this.queryCondition.eventStartTimeEnd
            },
            {
              code: 'planStartTime',
              symbol: 'between',
              values: this.queryCondition.planStartTimeBegin,
              valuesTwo: this.queryCondition.planStartTimeEnd
            },
            {
              code: 'planEndTime',
              symbol: 'between',
              values: this.queryCondition.planEndTimeBegin,
              valuesTwo: this.queryCondition.planEndTimeEnd
            },
            {
              code: 'oneLevelCode',
              symbol: 'like',
              values: this.queryCondition.oneLevelCode
            },
            {
              code: 'twoLevelCode',
              symbol: 'like',
              values: this.queryCondition.twoLevelCode
            },
            {
              code: 'threeLevelCode',
              symbol: 'like',
              values: this.queryCondition.threeLevelCode
            },
            {
              code: 'strainsName',
              symbol: 'like',
              values:this.queryCondition.strainsName
            }
          ]
        }
        this.listLoading2 = true // 开启加载动画
        findHistTask(queryData).then(res => {
          if (res.code === 1 && res.data) {
            this.tableData2 = res.data.list
            this.pagination2.total = res.data.total
            this.listLoading2 = false
          }
          this.listLoading2 = false
        })
      },
      handSearch() {
        if (this.activeName === 'first') {
          this.queryByPage(1)
        } else {
          this.queryByPage2(1)
        }
      },
      cb() {
        this.$store.commit('undoListPage/updateShowFilter', !this.showFilter)
      },
      // 客户来源
      getCustSelectList() {
        getCustSourceSelect().then(res => {
          if (res.code === 1 && res.data) {
            this.handleSelectList(0, res.data)
          }
        })
      },
      // 获取活动来源下拉框数据
      getFiveSource(level, parentId, custCode) {
        const data = {
          level: level,
          parentId: null,
          custSourceCode: null
        }
        if (parentId) {
          data.parentId = parentId
        }
        if (custCode) {
          data.custSourceCode = custCode
        }
        getSourceSelectList(data).then(res => {
          if (res.code === 1) {
            this.handleSelectList(level, res.data)
          }
        })
      },
      // 将来源分为一级二级三级，对应下拉框
      handleSelectList(level, data) {
        const param = {
          level: level,
          list: data
        }
        this.$store.commit('undoListPage/updateSourceList', param)
      },
      // custSourceChange(value) {
      //   if (value) {
      //     const data = this.custSourceList.find(item => item.code === value)
      //     this.getFiveSource(1, null, data.code)
      //   } else {
      //     // 清空1，2，3级来源列表
      //     this.handleSelectList(1, [])
      //     this.handleSelectList(2, [])
      //     this.handleSelectList(3, [])
      //   }
      // },
      
      oneSourceChange(value) {
        if (value) {
          const data = this.oneSourceList.find(item => item.sourceCode === value)
          this.getFiveSource(2, data.sourceId)
        } else {
          // 清空2，3级来源列表
          this.handleSelectList(2, [])
          this.handleSelectList(3, [])
        }
      },
      twoSourceChange(value) {
        if (value) {
          const data = this.twoSourceList.find(item => item.sourceCode === value)
          this.getFiveSource(3, data.sourceId)
        } else {
          // 清空3级来源列表
          this.handleSelectList(3, [])
        }
      },
      approveBatch() {
        // 判断是否有勾选数据
        if (this.$refs.xTable.selection.length < 1) {
          this.$message.warning('请至少勾选一条记录')
          return
        }

        // 判断所选数据是否可审批或者当前用户是否可审核
        let notApproveItem = this.$refs.xTable.selection.find(
            item => {
              /*  状态不是审批中 */
              if (item.eventStatus !== '审批中') {
                item._reason = '状态非“审批中”'
                return true
              }
              /* 用户不在审核人列表 */
              const idList = String(item.currentApproveUserIds || '')
                  .split(',')
                  .map(String)
              if (idList.indexOf(String(this.user.userId)) === -1) {
                item._reason = '您无法审核'
                return true
              }
              return false
            }
        );
        if (notApproveItem) {
          this.$message.warning( `所选记录（${notApproveItem.eventCode}）${notApproveItem._reason}`)
          return
        }

        this.$refs.xTable.selection.forEach(element => {
          element.approveMsg = this.batchApproveMsg
        })
        const data = this.$refs.xTable.selection
        this.batchApproveBtnLoading = true
        approveApplyBatchInDb(data).then(res => {
          if (res.code === 1) {
            this.$message.success('审批成功')
            this.batchApproveBtnLoading = false
            this.batchApproveDialogVisible = false
            this.handSearch()
          }
        })
      },
      // 获取品系
      getCarStrains() {
        queryCarStrainsInfo().then(res => {
          if (res.code === 1) {
            this.carStrainsDS = res.data.list
          }
        })
      }
    }
  }
  </script>
  <style lang="less">
  .el-input--medium .el-input__inner {
    height: 30px;
  }
  .operate {
    display: flex;
    justify-content: space-around;
  }
  .el-link {
    font-size: 12px;
  }
  .load-buttom {
    text-decoration: none;
    float: right;
    height: 30px;
    padding: 0 10px;
    text-align: right;
    line-height: 30px;
    color: #00a7e5;
    display: inline-block;
    font-size: 12px;
  }
  .load-buttom:hover {
    color: #00b7bf;
  }
  .err-box {
    margin-top: 10px;
  }
  .pic-box {
    display: inline-block;
    padding: 5px;
  }
  .a_height{
    width: 100% !important;
    .el-input__inner{
      height: 30px;
    }
  }
  </style>
   
  